import FacetFilter from '@/src/components/flch/components/filter/FacetFilter'
import { Facet } from '@/src/components/flch/components/filter/types'
import {
  EXPERIENCE_ORDER,
  experienceBucket,
  GEARBOX_OPTIONS,
  gearboxLabels,
  GENDER_OPTIONS,
  genderLabel,
  Teacher,
} from '@/src/components/flch/teacherLocation/lib'

const FACETS: Facet<Teacher>[] = [
  {
    name: 'Geschlecht',
    includeUnlabeled: true,
    labels: (teacher) => {
      const gender = genderLabel(teacher)
      return gender ? [gender] : []
    },
    options: (teachers) => {
      const set = new Set(GENDER_OPTIONS)
      for (const teacher of teachers) {
        const gender = genderLabel(teacher)
        if (gender) set.add(gender)
      }
      return [...set]
    },
  },
  {
    name: 'Sprache',
    labels: (teacher) => teacher.lessonLanguages,
    options: (teachers) => [
      ...new Set(teachers.flatMap((teacher) => teacher.lessonLanguages)),
    ],
  },
  {
    name: 'Jahre als Fahrlehrer:in',
    labels: (teacher) => {
      const bucket = experienceBucket(teacher)
      return bucket ? [bucket] : []
    },
    options: (teachers) => {
      const present = new Set(
        teachers
          .map(experienceBucket)
          .filter((bucket): bucket is string => bucket !== null)
      )
      return EXPERIENCE_ORDER.filter((bucket) => present.has(bucket))
    },
  },
  {
    name: 'Fahrzeug',
    labels: (teacher) => gearboxLabels(teacher),
    options: (teachers) => {
      const present = new Set(teachers.flatMap(gearboxLabels))
      return GEARBOX_OPTIONS.filter((gearbox) => present.has(gearbox))
    },
  },
]

const Filter = ({
  teachers,
  setFilteredTeachers,
}: {
  teachers: Teacher[]
  setFilteredTeachers: (teachers: Teacher[]) => void
}) => (
  <FacetFilter
    items={teachers}
    facets={FACETS}
    breakpoint="lg"
    resultLabel={(count) =>
      `${count} ${count === 1 ? 'Fahrlehrer:in' : 'Fahrlehrer:innen'} anzeigen`
    }
    onFilteredChange={setFilteredTeachers}
  />
)

export default Filter
